// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.inv_supplier_status_enum */
var InvSupplierStatusEnum;
(function (InvSupplierStatusEnum) {
    InvSupplierStatusEnum["PENDING"] = "PENDING";
    InvSupplierStatusEnum["APPROVED"] = "APPROVED";
    InvSupplierStatusEnum["REJECTED"] = "REJECTED";
})(InvSupplierStatusEnum || (InvSupplierStatusEnum = {}));
;
export default InvSupplierStatusEnum;
/** Zod schema for inv_supplier_status_enum */
export const invSupplierStatusEnum = z.nativeEnum(InvSupplierStatusEnum);
//# sourceMappingURL=InvSupplierStatusEnum.js.map